export const setupSearch = () => {
  const searchToggle = document.querySelector('.search-toggle') as HTMLButtonElement;
  const mobileToggle = document.querySelector('.mobile-toggle') as HTMLButtonElement;

  if (searchToggle) {
    searchToggle.addEventListener('click', (e) => {
      e.preventDefault();
      searchToggle.parentElement?.classList.toggle('active');
      if (mobileToggle && mobileToggle.classList.contains('active')) {
        mobileToggle.click();
      }
    });
  }
};
